export const APPLICATIONS_ALL_STATUSES_PATH = '/applications?analysisStatus=all';
